"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supplierCarbonFootprints = void 0;
const supplierCarbonFootprints = exports.supplierCarbonFootprints = {
  SUPPLIER_CARBON_FOOTPRINTS: {
    en: {
      title: 'Supplier Carbon Footprints',
      subtitle: 'Visualise Scope 3 emissions across your supply chain',
      description: 'Simplify emissions calculations, and measure and identify hotspots for carbon reduction with total visibility of emissions down to facility level.',
      list: ['Granular, supplier-specific data on 71 bulk chemicals and plastics', 'Accessed via an easy-to-use interface', 'Support longer-term investment', 'Set ambitious and realistic targets', 'Mitigate risk']
    },
    zh: {
      title: '供应商碳足迹',
      subtitle: '实现全供应链的范围3碳排放可视化',
      description: '全面了解装置层面的碳排放情况，简化碳排放计算，衡量并发现碳减排热点。',
      list: ['特定供应商的精细化数据，涵盖71种大宗化工品和塑料', '交互式界面易于使用', '支持更长期的投资决策', '制定远大而切实的目标', '降低风险']
    }
  }
};